var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'switch' + (_vm._active ? ' active' : ''),on:{"click":_vm.onChange}},[_c('div',{staticClass:"switch__switch"})])
}
var staticRenderFns = []

export { render, staticRenderFns }